import { Link, useNavigate, useParams } from "react-router-dom";
import patient from "../../../assets/img/patient.jpg";
import { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import Textarea from "../../../components/text-area";
import { prompts } from "../../../util/dummyJson";
import { ADMINPROMPTS } from "../../../action/apiPath";
import { CallWithAuth } from "../../../action/apiActions";
import { showToast } from "../../../util/toastHelper";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const AdminPromptsPageEdit = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const textareaRef = useRef(null);
  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height based on scrollHeight
    }
  };

  // Re-run on text change
  const [prompt, setPrompt] = useState({});

  useEffect(() => {
    adjustHeight(); // Adjust height on initial render
  }, [prompt]);
  useEffect(() => {
    getPromptData();
  }, []);
  const getPromptData = async () => {
    try {
      const response = await CallWithAuth("GET", ADMINPROMPTS);
      if (response.res.status == 200) {
        setPrompt((prev) => ({
          ...prev,
          background_info: response.res.data.data.background_info,
          collateral: response.res.data.data.collateral,
          mse: response.res.data.data.mse,
          standardised_assessment:
            response.res.data.data.standardised_assessment,
          clinical_interviews: response.res.data.data.clinical_interviews,
          formulation: response.res.data.data.formulation,
          diagnose: response.res.data.data.diagnose,
          recommendation: response.res.data.data.recommendation,
        }));
        // setPrompt(response.res.data.data);
      } else {
        showToast("error", response.res.data.message);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);

    }
  };

  const validatePromptData = (data) => {
    const errors = {};

    if (!data.background_info || data.background_info.trim() === "") {
      errors.background_info = "Background information is required.";
    }

    if (!data.collateral || data.collateral.trim() === "") {
      errors.collateral = "Collateral is required.";
    }

    if (!data.mse || data.mse.trim() === "") {
      errors.mse = "MSE (Mental State Examination) is required.";
    }

    if (
      !data.standardised_assessment ||
      data.standardised_assessment.trim() === ""
    ) {
      errors.standardised_assessment = "Standardised assessment is required.";
    }

    if (!data.clinical_interviews || data.clinical_interviews.trim() === "") {
      errors.clinical_interviews = "Clinical interviews are required.";
    }

    if (!data.formulation || data.formulation.trim() === "") {
      errors.formulation = "Formulation is required.";
    }

    if (!data.diagnose || data.diagnose.trim() === "") {
      errors.diagnose = "Diagnosis is required.";
    }

    if (!data.recommendation || data.recommendation.trim() === "") {
      errors.recommendation = "Recommendation is required.";
    }

    return errors;
  };
  const savePrompts = async () => {
    try {
      const errors = validatePromptData(prompt); // Replace `promptData` with your state variable

      if (Object.keys(errors).length > 0) {
        const firstError = Object.values(errors)[0]; // Get the first error message
        // toast.error(firstError, { position: toast.POSITION.TOP_RIGHT });
        showToast("error", firstError);        

        return;
      }
      const response = await CallWithAuth("PATCH", ADMINPROMPTS, prompt);
      if (response.res.status == 200) {
        showToast("success", "Prompt has been saved successfully.");
      } else {
        if (Array.isArray(response.res.data.message)) {
          showToast("error", response.res.data.message[0]);
        } else {
          showToast("error", response.res.data.message);
        }
      }
    } catch (error) {}
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPrompt((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <div className="full-page-loader">
            <div className="loader"></div>
          </div>
        </>
      )}
      <div>
        <section className="site_hero patient_management_banner">
          <div className="site_container">
            <div className="site_row">
              <div className="txt_colm">
                <div className="txt_block">
                  <h1>Prompts Manage</h1>
                </div>
              </div>
              <div className="img_colm">
                <div className="img_block">
                  {/* <img src={patient} alt="" /> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="site_container">
          <div className="row mx-auto mt-5">
            <div className="col-12 prompts_inner_block">
              <Textarea
                name="background_info"
                value={prompt.background_info}
                onChange={handleChange}
                fieldName="background info"
              />
            </div>

            <div className="col-12 prompts_inner_block">
              <Textarea
                name="clinical_interviews"
                value={prompt.clinical_interviews}
                onChange={handleChange}
                fieldName="clinical interviews"
              />
            </div>

            <div className="col-12 prompts_inner_block">
              <Textarea
                name="collateral"
                value={prompt.collateral}
                onChange={handleChange}
                fieldName="Collateral"
              />
            </div>

            <div className="col-12 prompts_inner_block">
              <Textarea
                name="mse"
                value={prompt.mse}
                onChange={handleChange}
                fieldName="Mse"
              />
            </div>
            <div className="col-12 prompts_inner_block">
              <Textarea
                name="standardised_assessment"
                value={prompt.standardised_assessment}
                onChange={handleChange}
                fieldName="Standardised assessment"
              />
            </div>

            <div className="col-12 prompts_inner_block">
              <Textarea
                name="clinical_interviews"
                value={prompt.clinical_interviews}
                onChange={handleChange}
                fieldName="clinical interviews"
              />
            </div>
            <div className="col-12 prompts_inner_block">
              <Textarea
                name="formulation"
                value={prompt.formulation}
                onChange={handleChange}
                fieldName="Formulation"
              />
            </div>
            <div className="col-12 prompts_inner_block">
              <Textarea
                name="diagnose"
                value={prompt.diagnose}
                onChange={handleChange}
                fieldName="Diagnoses"
              />
            </div>

            <div className="col-12 prompts_inner_block">
              <Textarea
                name="recommendation"
                value={prompt.recommendation}
                onChange={handleChange}
                fieldName="recommendation"
              />
            </div>
            <button onClick={savePrompts} className="button_save_prompts mt-5">
              Save Prompts
            </button>
          </div>
        </section>
      </div>
      <ToastContainer />
    </>
  );
};
export default AdminPromptsPageEdit;
